const initialState = {
  pagination: {
    documentsPerPage: 10,
    pageNumber: 1
  }
};

export default {
  state: JSON.parse(JSON.stringify(initialState)),
  mutations: {
    SET_CURRENT_PAGINATION_BROKER: (state, value) => {
      state.pagination = value;
    },
    SET_PAGINATION_DOC_PER_PAGE_BROKER: (state, value) => {
      state.pagination.documentsPerPage = value;
    },
    SET_PAGINATION_PAGE_NUMBER_BROKER: (state, value) => {
      state.pagination.pageNumber = value;
    }
  },
  actions: {
    setCurrentPaginationBroker({ commit }, paginationObj) {
      commit('SET_CURRENT_PAGINATION_BROKER', paginationObj);
    },
    setPaginationDocumentsPerPageBroker({ commit }, documentPerPage) {
      commit('SET_PAGINATION_DOC_PER_PAGE_BROKER', documentPerPage);
    },
    setPaginationPageNumberBroker({ commit }, pageNumber) {
      commit('SET_PAGINATION_PAGE_NUMBER_BROKER', pageNumber);
    }
  }
};
